import { render, staticRenderFns } from "./EmailLogsControl.vue?vue&type=template&id=0648d3f0&scoped=true"
import script from "./EmailLogsControl.vue?vue&type=script&lang=js"
export * from "./EmailLogsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648d3f0",
  null
  
)

export default component.exports